import {
  FieldMappingDatePicker,
  FieldMappingDatePickerProps,
} from '@components/field-mapping-date-picker';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingDatePickerProps<T = unknown> = FormFieldProps<
  FieldMappingDatePickerProps,
  T
>;

export function FormFieldMappingDatePicker<T>(props: FormFieldMappingDatePickerProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'field-mapping' });

  return <FieldMappingDatePicker {...props} {...formFieldProps} />;
}
